import {Component, ChangeDetectionStrategy, Input} from '@angular/core';

@Component({
  selector: 'girko-logo',
  template: `
    <a href="{{url || '/'}}" [ngStyle]="{color: color || 'white'}">
      <img class="logo"
           src="/assets/images/logo.svg"
           onerror="this.onerror=null; this.src='/assets/images/logo.png'"
           alt="Girko.net logo"/>
      <span class="text">{{label || 'GIRKO'}}</span>
    </a>
  `,
  styles: [`
    :host {
      padding: 9px 15px;
      display: inline-block;
      white-space: nowrap;
    }

    .logo {
      height: 32px;
      width: 32px;
      display: inline-block;
    }

    .text {
      display: inline-block;
      vertical-align: middle;
      margin-left: 8px;
      font-size: 20px;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoComponent {
  @Input() label: string;
  @Input() color: string;
  @Input() url: string;
}
